import gql from 'graphql-tag'

export default gql `
    mutation deleteFile($key: String!){
        deleteFile(
            key: $key
        )
    }
`